
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Distinta, RigaDistinta, StatoVariazioneRigaDistinta, VariazioneRigaDistinta, RigaInValidazione } from "@/models";
import { store, StoreActions, StoreMutations } from '@/store';

@Component
export default class RigaDistintaListaVariazioni extends Vue {
    
    @Prop() private rigaDistinta!: RigaInValidazione;

    private StatoVariazione = StatoVariazioneRigaDistinta;

    private mostraVariazioniStoricizzate = false;

    get variazioniDaMostrare(): VariazioneRigaDistinta[] {
        if(this.rigaDistinta.variazioniComunicate) {
            let indiceAttivo = this.mostraVariazioniStoricizzate === true ? -1 :  this.rigaDistinta.indiceVariazioneAttiva || 0;
            return this.rigaDistinta.variazioniComunicate.filter(x => x && x.indice > indiceAttivo);
        }
        return [];
    }

    get contieneVariazioniStoricizzate() : boolean {
        if(this.rigaDistinta.variazioniComunicate) {
            return this.rigaDistinta.variazioniComunicate.filter(x => x && x.indice != 0).length > 0;
        }
        return false;
    }
}
